
/* injects from baggage-loader */

'use strict'

import StageBaseController from '../stage-base.controller';

import { 
    introBallons, 
    tutorialBallons,
    abeldoChallenge1Ballons,
    scene1, 
    scene2,
    exercise1,
    exercise2,
    exercise3,
    exercise4,
    exercise5,
    exercise6,
    successExercise1,
    successExercise2,
    successExercise3,
    successExercise4,
    successExercise5,
    successExercise6,
    failExercise1,
    failExercise2,
    failExercise3,
    failExercise4,
    failExercise5,
    failExercise6
} from './stage-four.const'

import { 
    topLeftWithStatusBarPosition, 
    bottomRightBallonPosition, 
    CharThumbs 
} from '_appRoot/index.const';

import gifAnimation from '_images/stages/stage-four/chroma-animation.gif';

import { shuffle } from 'lodash';

export default class StageFourController extends StageBaseController {
    constructor($log, $rootScope, $state, $timeout, Dialog, Trophies, Session) {
        'ngInject';
        super($log, $rootScope, $state, $timeout, Dialog, Trophies, Session, 3);

        this.state = {
            step: 1,
            lastStep: 5
        }

        this.ballons = {
            ballon1: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: introBallons,
                position: topLeftWithStatusBarPosition
            },
            ballon2: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: tutorialBallons,
                position: topLeftWithStatusBarPosition
            },
            abeldo: {
                visible: false,
                thumb: CharThumbs.abeldo,
                dialogs: [],
                position: bottomRightBallonPosition
            },
            success: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: [],
                position: topLeftWithStatusBarPosition
            },
            fail: {
                visible: false,
                thumb: CharThumbs.vernaculo,
                dialogs: [],
                position: topLeftWithStatusBarPosition
            }
        }

        this.scene1 = scene1;
        this.scene2 = scene2;

        this.magazine1 = require('_images/stages/stage-four/exercise-1/magazine.png');
        this.magazine1Gt = require('_images/stages/stage-four/exercise-1/magazine-gt.png');
        this.magazine5 = require('_images/stages/stage-four/exercise-5/magazine.png');
        this.magazine5Gt = require('_images/stages/stage-four/exercise-5/magazine-gt.png');
        this.magazine6 = require('_images/stages/stage-four/exercise-6/magazine.png');
        this.magazine6Gt = require('_images/stages/stage-four/exercise-6/magazine-gt.png');
        
        this.gifAnimation = gifAnimation;

        this.model = {
            exercise1: {
                value: null,
                data: shuffle(exercise1),
                correctValue: 4
            },
            exercise2: {
                value: null,
                data: shuffle(exercise2),
                correctValue: 1
            },
            exercise3: {
                value: null,
                data: shuffle(exercise3),
                correctValue: 4
            },
            exercise4: {
                value: null,
                data: shuffle(exercise4),
                correctValue: 2
            },
            exercise5: {
                value: null,
                data: shuffle(exercise5),
                correctValue: 1
            },
            exercise6: {
                value: null,
                data: shuffle(exercise6),
                correctValue: 4
            }
        };
    }

    $onInit() {
        this.$timeout(() => {
            this.ballons.ballon1.visible = true;
        }, 800);
    }

    onCloseBallon1() {
        this.ballons.ballon1.visible = false;
        this.state.step++;

        // to next scene
        this.$timeout(() => {
            this.state.step++;            
        }, 2700)
    }

    onCloseBallon2() {
        this.ballons.ballon2.visible = false;
    }
    
    onScene1Finish() {
        this.state.step++;
        this.ballons.abeldo.dialogs = abeldoChallenge1Ballons;
        this.ballons.abeldo.visible = true;
    }

    onScene2Finish() {
        super.finish(() => {
            this.$timeout(() => this.state.step++, 1600);
        });
    }

    validateExercise1() {
        if (this.model.exercise1.value === this.model.exercise1.correctValue) {
            this.ballons.success.dialogs = successExercise1;
            this.ballons.success.onFinish = this.onFinishSuccessExercise1.bind(this);
            this.ballons.success.visible = true;
        } else {
            this.ballons.fail.dialogs = failExercise1;
            this.ballons.fail.visible = true;
        }
    }

    validateExercise2() {
        if (this.model.exercise2.value === this.model.exercise2.correctValue) {
            this.ballons.success.dialogs = successExercise2;
            this.ballons.success.onFinish = this.onFinishSuccessExercise2.bind(this);
            this.ballons.success.visible = true;
        } else {
            this.ballons.fail.dialogs = failExercise2;
            this.ballons.fail.visible = true;
        }
    }

    validateExercise3() {
        if (this.model.exercise3.value === this.model.exercise3.correctValue) {
            this.ballons.success.dialogs = successExercise3;
            this.ballons.success.onFinish = this.onFinishSuccessExercise3.bind(this);
            this.ballons.success.visible = true;
        } else {
            this.ballons.fail.dialogs = failExercise3;
            this.ballons.fail.visible = true;
        }
    }

    validateExercise4() {
        if (this.model.exercise4.value === this.model.exercise4.correctValue) {
            this.ballons.success.dialogs = successExercise4;
            this.ballons.success.onFinish = this.onFinishSuccessExercise4.bind(this);
            this.ballons.success.visible = true;
        } else {
            this.ballons.fail.dialogs = failExercise4;
            this.ballons.fail.visible = true;
        }
    }

    validateExercise5() {
        if (this.model.exercise5.value === this.model.exercise5.correctValue) {
            this.ballons.success.dialogs = successExercise5;
            this.ballons.success.onFinish = this.onFinishSuccessExercise5.bind(this);
            this.ballons.success.visible = true;
        } else {
            this.ballons.fail.dialogs = failExercise5;
            this.ballons.fail.visible = true;
        }
    }

    validateExercise6() {
        if (this.model.exercise6.value === this.model.exercise6.correctValue) {
            this.ballons.success.dialogs = successExercise6;
            this.ballons.success.onFinish = this.onFinishSuccessExercise6.bind(this);
            this.ballons.success.visible = true;
        } else {
            this.ballons.fail.dialogs = failExercise6;
            this.ballons.fail.visible = true;
        }
    }

    toLastExercise(){
        this.state.step = this.state.lastStep;
    }

    toMagazine(){
        this.state.step = 4;
    }

    toEndGame(){
        this.state.step = 13;
        this.$timeout(() => this.$state.go('main'), 3000);
    }

    toGameplay() {
        this.state.step++;

        this.$timeout(() => {
            this.ballons.ballon2.visible = true;
        }, 800);
    }

    onCloseBallonAbeldo(){
        this.ballons.abeldo.visible = false;
    }

    onFinishSuccessExercise1(){
        this.state.step++;
        this.state.lastStep = 6;
        this.ballons.success.visible = false;
    }

    onFinishSuccessExercise2(){
        this.state.step++;
        this.state.lastStep = 7;
        this.ballons.success.visible = false;
    }

    onFinishSuccessExercise3(){
        this.state.step++;
        this.state.lastStep = 8;
        this.ballons.success.visible = false;
    }

    onFinishSuccessExercise4(){
        this.state.step++;
        this.state.lastStep = 9;
        this.ballons.success.visible = false;
    }

    onFinishSuccessExercise5(){
        this.state.step++;
        this.state.lastStep = 10;
        this.ballons.success.visible = false;
    }
    
    onFinishSuccessExercise6() {
        this.state.step++;
        this.state.lastStep = 11;
        this.ballons.success.visible = false;
    }

    onFinishFail(){
        this.ballons.fail.visible = false;
        super.onFinishFail();        
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-four/stage-four.controller.js